// This file acts as the single source of truth for configuration values.
// All fetch requests and environment-specific settings should use these constants.

const isLocalhost = typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

// Prefer explicit env config when available, even on localhost
const ENV_API = (typeof import.meta !== 'undefined' && import.meta.env?.VITE_API_URL?.trim())
  ? import.meta.env.VITE_API_URL.trim()
  : '';
const FORCE_REMOTE = (typeof import.meta !== 'undefined' && import.meta.env?.VITE_FORCE_REMOTE?.trim())
  ? (import.meta.env.VITE_FORCE_REMOTE.trim() === 'true')
  : false;

// Honor explicit env override even on localhost; fallback appropriately
const DEFAULT_RENDER_API = 'https://qrsbackend-30ml.onrender.com/api';
const DEFAULT_LOCAL_API = 'https://qrsbackend-30ml.onrender.com/api';

// When running the Vite dev server on localhost, force using the Render API
// unless PREVIEW_OFFLINE is true or an explicit ENV_API is provided.
// This prevents accidental connections to non-existent local ports (e.g., 10001).
export const API_BASE_URL = DEFAULT_RENDER_API;

export const APP_BASE_URL = (typeof import.meta !== 'undefined' && import.meta.env?.VITE_APP_URL?.trim())
  ? import.meta.env.VITE_APP_URL.trim()
  : 'https://qrs.qssun.solar';

export const IS_DEVELOPMENT = (typeof import.meta !== 'undefined' && import.meta.env?.VITE_ENVIRONMENT?.trim())
  ? import.meta.env.VITE_ENVIRONMENT.trim() === 'development'
  : false;

export const IS_PRODUCTION = !IS_DEVELOPMENT;

// Export localhost flag to allow preview-only behavior when running on localhost
export const IS_LOCALHOST = isLocalhost;

// Add VAPID public key for Web Push subscriptions
export const VAPID_PUBLIC_KEY = (typeof import.meta !== 'undefined' && import.meta.env?.VITE_VAPID_PUBLIC_KEY?.trim())
  ? import.meta.env.VITE_VAPID_PUBLIC_KEY.trim()
  : '';

// Control offline preview behavior via env (default: false = connect to API)
export const PREVIEW_OFFLINE = (typeof import.meta !== 'undefined' && (import.meta as any).env?.VITE_PREVIEW_OFFLINE?.trim())
  ? ((import.meta as any).env.VITE_PREVIEW_OFFLINE.trim() === 'true')
  : false;

// Feature flag to control visibility of the Instant Expenses section.
// Default is false to keep the section hidden unless explicitly enabled.
// To enable, set VITE_INSTANT_EXPENSES_ENABLED=true in your environment.
export const INSTANT_EXPENSES_ENABLED = (typeof import.meta !== 'undefined' && (import.meta as any).env?.VITE_INSTANT_EXPENSES_ENABLED?.trim())
  ? ((import.meta as any).env.VITE_INSTANT_EXPENSES_ENABLED.trim() === 'true')
  : true;

if (typeof window !== 'undefined' && (import.meta as any)?.env?.DEV) {
  console.log('API_BASE_URL', API_BASE_URL);
  console.log('VAPID_PUBLIC_KEY set', Boolean(VAPID_PUBLIC_KEY));
  console.log('PREVIEW_OFFLINE', PREVIEW_OFFLINE);
  console.log('INSTANT_EXPENSES_ENABLED', INSTANT_EXPENSES_ENABLED);
}
